import React, { useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";

import { SecondaryButton } from "../ui/SecondaryButton";
import { PrimaryButton } from "../ui/PrimaryButton";
import FormTextField from "../ui/FormTextField";

function CorrectionForm({ onClose }) {
  const [correction, setCorrection] = useState("");
  const [block, setBlock] = useState("title");

  const handleSubmit = () => {
    console.log("Correction submitted:", { correction, block });
    onClose();
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Виправлення
      </Typography>

      {/* Label над TextField */}
      <FormTextField
        label="Введіть, що потрібно змінити"
        value={correction}
        onChange={(e) => setCorrection(e.target.value)}
      />

      {/* Label над Select */}
      <Typography sx={{ mb: 1 }}>Виберіть блок</Typography>
      <FormControl fullWidth sx={{ mb: 3 }} size="small">
        <Select
          value={block}
          onChange={(e) => setBlock(e.target.value)}
          displayEmpty
        >
          <MenuItem value="title">Заголовок</MenuItem>
          <MenuItem value="description">Опис</MenuItem>
          <MenuItem value="price">Ціна</MenuItem>
        </Select>
      </FormControl>

      <DialogActions sx={{ p: 0, justifyContent: "start" }}>
        <PrimaryButton onClick={handleSubmit}>Зберегти</PrimaryButton>
        <SecondaryButton onClick={onClose}>Закрити</SecondaryButton>
      </DialogActions>
    </Box>
  );
}

export default CorrectionForm;
